import { h } from 'preact';

const Info = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 12" role='img' {...props}>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M0.999735 0.668457C0.503735 0.668457 0.101184 1.07101 0.101184 1.56701C0.101184 2.06301 0.503735 2.46556 0.999735 2.46556C1.49573 2.46556 1.89829 2.06301 1.89829 1.56701C1.89829 1.07101 1.49573 0.668457 0.999735 0.668457Z" />
			<path d="M0.101074 4.71146C0.101074 4.2152 0.503369 3.8129 0.999625 3.8129C1.49588 3.8129 1.89818 4.2152 1.89818 4.71145V10.1028C1.89818 10.599 1.49588 11.0013 0.999625 11.0013C0.503369 11.0013 0.101074 10.599 0.101074 10.1028V4.71146Z" />
		</svg>
	);
};

export default Info;